function initGoToCart() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const cartVariantIds = cart.items.map(i => String(i.variant_id));
      document.querySelectorAll('add-to-cart-component').forEach(component => {
        const variantId = component.dataset.variantId;
        if (cartVariantIds.includes(variantId)) {
          setGoToCart(component);
        }
      });
    });
}

document.addEventListener('DOMContentLoaded', initGoToCart);
document.addEventListener('page:load', initGoToCart);
document.addEventListener('shopify:section:load', initGoToCart);

document.addEventListener('submit', (e) => {
  const form = e.target.closest('[data-type="add-to-cart-form"]');
  if (!form) return;
  setTimeout(() => {
    document.querySelectorAll('add-to-cart-component').forEach(component => {
      const variantId = component.dataset.variantId;
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          const cartVariantIds = cart.items.map(i => String(i.variant_id));
          if (cartVariantIds.includes(variantId)) {
            setGoToCart(component);
          }
        });
    });
  }, 1000);
});

function setGoToCart(component) {
  if (component.dataset.goToCart) return;
  component.dataset.goToCart = 'true';

  const btn = component.querySelector('button[name="add"]');
  const defaultText = component.querySelector('.atc-default-text');
  const gotoText = component.querySelector('.atc-goto-text');
  if (!btn || !gotoText) return;

  btn.type = 'button';
  if (defaultText) defaultText.style.display = 'none';
  gotoText.style.display = 'inline';

  btn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = '/cart';
  }, { capture: true });
}